<template>
    <div class="terms-and-conditions container">
        <div class="goback">
            <button @click="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" width="67" height="25" viewBox="0 0 67 25">
                    <text id="_voltar" data-name="&lt; voltar" transform="translate(0 19)" fill="#aeaeae" font-size="18" font-family="Poppins-Regular, Poppins"><tspan x="0" y="0">&lt; {{ $t('back') }}</tspan></text>
                </svg>
            </button>
        </div>
        <h1 class="v-content-terms-and-conditions" v-termsAndConditions="{ section: 'Termos e condições', removeHtml: true }">
            Termos e condições
        </h1>
        <p class="v-content-terms-and-conditions" v-termsAndConditions="{ section: 'Termos e condições', removeHtml: true }">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas placerat pharetra finibus. Sed a cursus erat, id laoreet augue. Praesent sed gravida risus. Sed tempor dui nec eros viverra, at tempus neque eleifend. Praesent id justo eu risus vestibulum blandit. Praesent fringilla lobortis tempus. Curabitur feugiat dolor ut ligula blandit eleifend. Quisque ornare, velit ut condimentum euismod, lacus urna consequat ipsum, sit amet volutpat erat urna vitae augue. Aenean viverra felis diam, sit amet congue nunc sollicitudin a.

            Etiam ut faucibus risus, ac placerat libero. Ut blandit luctus nibh, a egestas odio pulvinar ut. Proin eu mi ante. Ut tempor iaculis placerat. Sed tempor tellus posuere dapibus ultrices. Nullam fermentum feugiat dolor, eget pulvinar diam malesuada nec. Vivamus id ligula accumsan nisi rhoncus facilisis. Ut semper nisl id nulla hendrerit, sit amet iaculis leo venenatis. Phasellus sollicitudin, nisi facilisis sagittis interdum, neque lectus aliquam tellus, eu posuere neque ligula sit amet urna.

            Duis pretium rutrum commodo. Vestibulum vel cursus metus, in ullamcorper turpis. Sed pretium commodo congue. Sed et tellus at augue euismod convallis. Vestibulum et sapien id ipsum rhoncus vulputate non eu nulla. Phasellus ut tempor enim. Aliquam molestie pellentesque urna eu ultrices. Mauris quis neque quis ante convallis venenatis.

            Duis et risus bibendum ante venenatis auctor. Praesent a orci eget sapien fringilla commodo in in urna. Aliquam erat volutpat. Duis ac vehicula purus, a eleifend dui. Duis ac elit eget libero mollis finibus ac in lacus. Vestibulum varius diam nec tincidunt porta. Sed eu quam fringilla, placerat tortor sit amet, volutpat metus. In hac habitasse platea dictumst. Cras semper pretium magna, vel posuere justo euismod viverra. Nunc dignissim porttitor nisl, nec tempor lectus semper vel. Proin varius auctor mauris, in varius tortor commodo nec. Suspendisse at ante eu diam ultricies aliquam. Aenean est urna, suscipit pharetra mi vitae, pharetra maximus orci. Aenean eu metus rutrum, tempus risus id, rhoncus massa.

            Maecenas id neque ut lorem vehicula porttitor. Vestibulum ut mattis felis. Nullam vel erat ac massa tristique ullamcorper ut sit amet sem. Vestibulum auctor tortor ut tortor pulvinar, vel lacinia risus porta. Cras porttitor varius gravida. Aenean et urna odio. Phasellus et maximus urna. Pellentesque id gravida odio. Aliquam quis accumsan sapien. Fusce nec volutpat felis. Curabitur egestas ligula eu quam elementum, ac imperdiet ipsum facilisis. Pellentesque faucibus sem in mi cursus dapibus.
        </p>
    </div>
</template>
<script>
import store from "@/store";
import { mapState } from 'vuex';
import axios from 'axios';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
   computed: {
    ...mapState('App', ['loading']),
  },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        updateDirectives() {
            store.dispatch('App/loading', true);
            const allElements = document.querySelectorAll('.v-content-terms-and-conditions');
            allContents.splice(0, allContents.length); // clear the contents array
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                (!('type' in params) ? params.type = 'text' : null);
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
            store.dispatch('App/loading', false);

        },
    },
    created() {
        this.updateDirectives();
    },
    directives: {
      termsAndConditions: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-terms-and-conditions');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-terms-and-conditions');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
};
</script>´
<style lang="scss" scoped>
.terms-and-conditions {
    padding: 150px 0;
    max-width: 1200px;
    font-size: 18px;
    line-height: 24px;
    font-family: 'Font Regular';
    text-align: left;
    h1{
        font-family: 'Font Bold';
        font-size: 35px;
        color: #E84E0F;
        text-align: left;
        margin-bottom: 30px;
    }
}
</style>